module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "275",
      "src": "images/11.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s important to keep a running balance of the funds in your checking account as well as balancing your checkbook against your bank statement every month. If you have a computer, the easiest way to do this is by purchasing software such as Quicken or Microsoft Money. These programs make it easy to electronically track your banking transactions as well as help you balance your checking account.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Balancing your checkbook in five easy steps")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("1. Write down the ending balance shown on your monthly bank statement.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("2. List all deposits you’ve made that are not on the bank statement.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("3. List all the check amounts and other withdrawals that you have made that are not included on the bank statement.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("4. Add the total amount of the deposits in step 2 to the ending balance in step 1.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("5. Subtract all of the withdrawals in step 3 from total in step 4. This total should match your checkbook balance")])]), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Checkbook balancing worksheet")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Ending balance shown on bank statement")]), _vm._v(" "), _c('td', [_vm._v("__________")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Add all deposits not shown on bank statement")]), _vm._v(" "), _c('td', [_vm._v("__________")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', [_vm._v("__________")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Subtract all checks, withdrawals, and fees not shown on statement")]), _vm._v(" "), _c('td', [_vm._v("___")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total adjusted ending balance")]), _vm._v(" "), _c('td', [_vm._v("__________")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Current checkbook balance")]), _vm._v(" "), _c('td', [_vm._v("__________")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your checkbook is balanced when the total adjusted ending balance on your monthly bank statement equals the ending balance in your checkbook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebartit"
  }, [_vm._v("Running balance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keeping a running balance means adding the money you put into your account and subtracting the money you take out on a daily basis. Money disappears quicker than you think. Knowing exactly what you have in your account will save you a lot of grief.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartit"
  }, [_vm._v("Bounce, bounce, bounce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your check bounces when you don’t have enough money in your account to cover the amount of the check. Bad things happen when this occurs. You will be charged fines by both your bank and the business to which you wrote the check. These fines could be as high as $75 per check bounced. Ouch. Writing a bad check, or writing a check knowing you don’t have enough money in your account is a crime and can land you in jail. Don’t do it!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71d91ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch07.vue
// module id = 105
// module chunks = 0